<section class="flex flex-col gap-1.25">
  <div class="flex gap-0.46875">
    <app-button
      data-qa="models-button-investment"
      [size]="'small'"
      [type]="selectedTab === MODELS_URLS.INVESTMENT ? 'grey-accent' : 'grey'"
      [iconName]="'presentation-chart.svg'"
      (buttonClick)="navigateTo(MODELS_URLS.INVESTMENT)">
      Investment
    </app-button>
    <app-button
      data-qa="models-button-budget"
      [size]="'small'"
      [type]="selectedTab === MODELS_URLS.FUND_BUDGET ? 'grey-accent' : 'grey'"
      [iconName]="'coins-stacked.svg'"
      (buttonClick)="navigateTo(MODELS_URLS.FUND_BUDGET)">
      Budget
    </app-button>
  </div>
  <div>
    <router-outlet/>
  </div>
</section>
